import standardAPI from '@/api/standard_items';

const state = {
  excursion_directions: [],
  excursion_directions_status: '',
  excursion_directions_MetaData: {},
  excursion_directions_page: 1,
  excursion_directions_perPage: 10,
};

const responseUrl = '/excursion/directions';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_excursion_directions ({ commit }, getOptions) {
    commit('EXCURSION_DIRECTIONS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('EXCURSION_DIRECTIONS_SUCCESS', response);
            commit('EXCURSION_DIRECTIONS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('EXCURSION_DIRECTIONS_READY');
            reject(response);
          } else {
            commit('EXCURSION_DIRECTIONS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_excursion_direction ({ commit, dispatch }, itemData) {
    commit('EXCURSION_DIRECTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('EXCURSION_DIRECTIONS_READY');
          reject(response);
        }
      });
    });
  },
  edit_excursion_direction ({ commit, dispatch }, itemData) {
    commit('EXCURSION_DIRECTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('EXCURSION_DIRECTIONS_READY');
          reject(response);
        }
      });
    });
  },
  remove_excursion_direction ({ commit, dispatch }, itemData) {
    commit('EXCURSION_DIRECTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('EXCURSION_DIRECTIONS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_excursion_direction ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_excursion_direction_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.excursion_directions_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.excursion_directions_perPage = max;
  },
  EXCURSION_DIRECTIONS_READY: (state) => {
    state.excursion_directions_status = 'ready';
  },
  EXCURSION_DIRECTIONS_REQUEST: (state) => {
    state.excursion_directions_status = 'loading';
  },
  EXCURSION_DIRECTIONS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.excursion_directions_MetaData.meta = response.meta;
      state.excursion_directions_MetaData.links = response.links;
    }
    state.excursion_directions = response.data;
    state.excursion_directions_status = 'success';
  },
  EXCURSION_DIRECTIONS_ERROR: (state) => {
    state.excursion_directions_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
